export default __webpack_public_path__ + "static/media/courseDescriptionB.6e0767c0.png";